import React from 'react';
import StyledSubpageBanner from './styledSubpageBanner';

const SubpageBanner = () => <StyledSubpageBanner />;

export default SubpageBanner;
